<template>
  <div style="min-width: 375px; max-width: 900px;" class="p-1" >
    <b-card no-body>
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button
          block
          variant="light"
          size="sm"
          style="color:darkred;"
          class="text-left"
          @click="$emit('journal-view')"
        >
          <b>&lt; Journal</b>
        </b-button>
      </b-card-header>
    </b-card>

    <b-card no-body header-tag="header" class="align-bottom mt-1">
      <template v-slot:header>
        <b>
          <span class="float-left">
            <b-button
              variant="outline-secondary"
              v-b-modal="'add-image'+projectId+journalDate" 
              @click="closeTooltip"
              size="sm"
              v-b-tooltip.hover
              title="Add photo..."
              style="padding: 0rem 0.25rem;"
            >
              <img alt="add photo" src="@/assets/images/add-photo-icon.svg" height="24px" />
            </b-button>
          </span> 
          <div class="text-center"> Photos </div>
        </b>
      </template>
    </b-card>

    <div v-if="isBusy" class="text-center p-4"><b-spinner> </b-spinner></div>

    <b-row v-for="item in data" :key="item.id" class="m-0 pt-1">
    
      <b-card no-body bg-variant="light" class="pb-2 pt-2" style="width:900px;">
        <b-container class="m-0 p-0">
          <b-row class="m-0">
            <b-col sm class="m-0 p-0">
              <div>
                <b-button variant="outline-light" @click="showPhoto(item.blobUrl)">
                  <b-img-lazy :src="'data:image/jpeg;base64,' + item.thumbnail" alt="photo" fluid></b-img-lazy>
                </b-button>
              </div>
              <div class="text-center">
                  <small>{{item.fileName}}</small>
              </div>
            </b-col>

            <b-col sm>
             <div class="text-left pt-2">
              <strong>{{ item.caption }}</strong>
              <div class="p-2" style="white-space: pre-line;">{{item.remarks}}</div>

              <div class="text-right">
                <b-button variant="outline-secondary" size="sm" 
                @click="editPhoto(item)" 
                v-b-tooltip.hover
                title="Edit..."
                style="padding: 0rem 0.25rem;" > <img alt="add photo" src="@/assets/images/edit-icon.svg" height="32px" /></b-button>
              </div>
             </div> 
            </b-col>
          </b-row>
        </b-container>
      </b-card>
    
    </b-row>

    <!-- The modal addImage -->
    <b-modal
      v-bind:id="'add-image'+projectId+journalDate"
      title="Add Image"
      v-bind:size="modalSize"
      hide-footer
    >
      <AddImage
        v-bind:projectId="projectId"
        :journalDate="journalDate"
        @upsize="upsizeModal"
        @exit="closeModal"
      ></AddImage>
    </b-modal>

    <!-- The modal editPhoto -->
    <b-modal
      v-bind:id="'edit-photo'+projectId+journalDate"
      title="Edit Photo Details"
      size="lg"
      hide-footer 
    >
      <EditPhoto :photo="photo" @close="closeEditPhoto" @save="saveEdits" @remove="removePhoto"></EditPhoto>
    </b-modal>

    <!-- The modal showPhoto -->
    <b-modal v-bind:id="'show-photo'+projectId+journalDate" size="xl" hide-footer>
      <div v-if="!photoLoaded" class="text-center">
        <b-spinner label="Loading..."></b-spinner>
      </div>
      
      <b-img v-show="photoLoaded" :src="imgSrc" v-on:load="onLoaded" @error="onImageError" fluid></b-img>

      <div v-if="imageError">
        <b-alert class="text-center" show variant="danger">Error loading image.</b-alert>
      </div>
    </b-modal>
 
  </div>
</template>

<script>
import AddImage from "@/components/journal/AddImage.vue";
import EditPhoto from "@/components/journal/EditPhoto.vue";
import { Stream } from "stream";

export default {
  name: "PhotoPage",
  components: {
    AddImage,
    EditPhoto
  },
  props: ["projectId", "journalDate"],
  data: function() {
    return {
      data: null,
      modalSize: "md",
      isBusy: false,
      loaded: false,
      errored: false,
      error: "",
      imgSrc: "",
      photoLoaded: false,
      imageError: false,
      editId: null,
      photo: null,
      Sas: ""
    };
  },
  methods: {
    fetchData() {
      this.isBusy = true;
      this.$auth.acquireToken().then(token => {
          this.$http
          .get("api/JournalPhotos/" + this.projectId + "/" + this.journalDate, {
            headers: { Authorization: "Bearer " + token }
          })
        .then(response => {
          this.data = response.data;
          this.loaded = true;
        })
        .catch(error => {
          this.errored = true;
          this.loaded = false;
          this.error = error.response.statusText;
        })
        .finally(() => (this.isBusy = false));
    });
  },

    saveEdits(val) {
      let formData = new FormData();
      formData.append("Id", val.id);
      if (val.caption){
        formData.append("Caption", val.caption.trim())
      };
      if (val.remarks){
        formData.append("Remarks", val.remarks.trim())
      };

      this.$auth.acquireToken().then(token => {
        this.$http
          .put("api/JournalPhotos/" + val.id, formData, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            let item = this.data.find(x => x.id === val.id);
            item.caption = val.caption;
            item.remarks = val.remarks;
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            this.$bvModal.hide(
              "edit-photo" + this.projectId + this.journalDate
            );
          });
      });
    },

    onImageError(e) {
      console.log(e);
      //to-do: consider refresh Sas token to handle if error is 404?
      this.isBusy = false;
      this.photoLoaded = true;
      this.imageError = true;
    },

    onLoaded() {
      this.isBusy = false;
      this.photoLoaded = true;
    },

    showPhoto(url) {
      this.photoLoaded = false;
      this.imageError = false;
      
      if (this.Sas)
        {
          this.$bvModal.show("show-photo" + this.projectId + this.journalDate);
          this.imgSrc = url+this.Sas;  
        }   
      else
       {
        this.$auth.acquireToken().then(token => {
        this.$http.get(
        "api/ContainerSas",
        {
          headers: { Authorization: "Bearer " + token }
        }
        )
        .then(response => {
          this.Sas = response.data;
          this.$bvModal.show("show-photo" + this.projectId + this.journalDate);
          this.imgSrc = url+this.Sas;
        })
       });  
      }
    },

    showModal(id) {
      this.modalSize = "md";
      this.$bvModal.show(id);
    },

    closeModal() {
      var id = "add-image" + this.projectId + this.journalDate;
      this.$bvModal.hide(id);
      this.fetchData();
    },

    upsizeModal() {
      this.modalSize = "xl";
    },

    editPhoto(photo) {
      //console.log(photo);
      this.photo = photo;
      this.$root.$emit('bv::hide::tooltip');
      this.$bvModal.show("edit-photo" + this.projectId + this.journalDate);
    },

    closeEditPhoto() {
      this.$bvModal.hide("edit-photo" + this.projectId + this.journalDate);
    },

    removePhoto(id) {
      //call api with data for delete
      this.$auth.acquireToken().then(token => {
        this.$http
          .delete("api/JournalPhotos/" + id, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            //reactive remove data object
            let i = this.data.findIndex(x => x.id === id);
            this.data.splice(i, 1);
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            this.$bvModal.hide("edit-photo" + this.projectId + this.journalDate);
          });
      });

    },
    closeTooltip(){
      this.$root.$emit('bv::hide::tooltip');  //force close toolip - seems to be ios display issue
    }
  },

  mounted: function() {
    this.isBusy = true;
    this.fetchData();
  }
};
</script>

<style scoped>
</style>